// import client from '../../Services/axiosConfig'; // or your axios instance
import { getProducts } from "../../Services/MainServices";

export const GET_FILTERED_PRODUCTS_REQUEST = "GET_FILTERED_PRODUCTS_REQUEST";
export const GET_FILTERED_PRODUCTS_SUCCESS = "GET_FILTERED_PRODUCTS_SUCCESS";
export const GET_FILTERED_PRODUCTS_FAILURE = "GET_FILTERED_PRODUCTS_FAILURE";

// export const getFilteredProducts =
//   (filters, withPage = false) =>
//   async (dispatch, getState) => {
//     const { auth } = getState();
//     const isAuthenticated = auth?.isAuthenticated;
//     dispatch({ type: GET_FILTERED_PRODUCTS_REQUEST });

//     try {
//       const {
//         categories = [],
//         subCategory = "",
//         sizes = [],
//         colors = [],
//         tags = [],
//         price = { min: 0, max: 0 },
//         search = "",
//         searchTerm = "",
//         types = [],
//         page = 1,
//       } = filters;

//       const params = {};

//       if (categories && categories.length > 0)
//         params["category"] = categories[0];
//       if (subCategory) params["sub_category"] = subCategory;
//       if (sizes.length > 0) params["sizes"] = sizes.join(",");
//       if (colors.length > 0) params["colors"] = colors.join(",");
//       if (tags.length > 0) params["tags"] = tags.join(",");
//       if (types.length > 0) params["product_types"] = types.join(",");
//       if (isAuthenticated && price.min !== null && price.max !== null) {
//         // params["price[min]"] = price.min;
//         // params["price[max]"] = price.max;
//         params["min_price"] = price.min;
//         params["max_price"] = price.max;
//       }
//       if (page > 1 && withPage) params["page"] = page;
//       if (search) params["search"] = search;
//       if (searchTerm) params["search"] = searchTerm;

//       const response = await getProducts(params);
//       // await client({
//       //   url: "/products/",
//       //   method: "GET",
//       //   params,
//       // });

//       dispatch({
//         type: GET_FILTERED_PRODUCTS_SUCCESS,
//         payload: response.data,
//       });
//     } catch (error) {
//       dispatch({
//         type: GET_FILTERED_PRODUCTS_FAILURE,
//         payload: error.response?.data?.message || error.message,
//       });
//     }
//   };

export const getAllProducts =
  ({ categories = [], subCategory = "", page = 1 }) =>
  async (dispatch) => {
    dispatch({ type: GET_FILTERED_PRODUCTS_REQUEST });

    try {
      const params = {};

      if (categories.length > 0) params.category = categories[0];
      if (subCategory) params.sub_category = subCategory;
      if (page > 1) params.page = page;

      const response = await getProducts(params);

      dispatch({
        type: GET_FILTERED_PRODUCTS_SUCCESS,
        payload: response.data,
      });
    } catch (error) {
      dispatch({
        type: GET_FILTERED_PRODUCTS_FAILURE,
        payload: error.message,
      });
    }
  };

export const getFilteredProducts =
  ({ filters, page = 1 }) =>
  async (dispatch, getState) => {
    const { auth } = getState();

    const isAuthenticated = auth?.isAuthenticated;

    dispatch({ type: GET_FILTERED_PRODUCTS_REQUEST });

    try {
      const {
        sizes = [],
        colors = [],
        tags = [],
        price = { min: 0, max: 5000 },
        search = "",
        searchTerm = "",
        types = [],
      } = filters;

      const DEFAULT_PRICE = { min: 0, max: 5000 };

      const params = {};

      if (sizes.length) params.sizes = sizes.join(",");
      if (colors.length) params.colors = colors.join(",");
      if (tags.length) params.tags = tags.join(",");
      if (types.length) params.product_types = types.join(",");

      if (
        isAuthenticated &&
        (price.min !== DEFAULT_PRICE.min || price.max !== DEFAULT_PRICE.max)
      ) {
        params.min_price = price.min;
        params.max_price = price.max;
      }

      if (search) params.search = search;
      if (searchTerm) params.search = searchTerm;

      console.log("params", params);

      // ✅ filtered pagination ALWAYS allowed
      if (page > 1) params.page = page;

      const response = await getProducts(params);

      dispatch({
        type: GET_FILTERED_PRODUCTS_SUCCESS,
        payload: response.data,
      });
    } catch (error) {
      dispatch({
        type: GET_FILTERED_PRODUCTS_FAILURE,
        payload: error.message,
      });
    }
  };
